export function getKeyPointMap(point: { [key: string]: any } | Array<string>) {
  const list = Array.isArray(point) ? point : Object.keys(point);
  return list.reduce((pre: any, cur: any) => ({ ...pre, [cur]: cur }), {});
}

export function getKeyMapIdPointMap(point: { [key: string]: any }) {
  const list = Object.keys(point);
  return list.reduce((pre: any, cur: string) => {
    const value = point[cur].buttonId;
    return { ...pre, [cur]: value };
  }, {});
}
